import type {ReactElement} from 'react';
import {useState} from 'react';
import type {SOURCE} from '@Libraries/stock-graphic-library';
import type {GridItemProps} from '../grid-item';
import type {GridMediaItemStorage, GridMediaItemTag} from '../grid-media-item';
import {GridMediaItemTagType} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import styles from '@Components/base-grid/components/grid-extracted-getty-sticker-item/grid-extracted-getty-sticker-item.module.scss';
import {CostTag} from '@Components/cost-tag';
import {SourceTag} from '@Components/source-tag';

export interface GridClipartItemStorage extends GridMediaItemStorage {
  thumbSrc: string;
  source: SOURCE;
  data: Record<string, any>;
}

export interface GridClipartItemBackEndData {
  id: string;
  hidden: boolean;
  tu: string;
  u: string;

  [key: string]: any;
}

interface GridClipartItemProps extends GridItemProps {
  thumbSrc: string;
  paddedThumb?: boolean;
  tag?: GridMediaItemTag;
}

export function GridClipartItem({...props}: GridClipartItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const getTag = (): ReactElement<any> => {
    return (
      <div className={`${styles.tagContainer} _full-width _full-height`}>
        {props.tag?.type === GridMediaItemTagType.COST ? (
          <CostTag containerStyle={props.tag.containerStyle} textStyle={props.tag.textStyle} icon={props.tag.icon} price={props.tag.price} />
        ) : (
          <SourceTag containerStyle={props.tag?.containerStyle} contentStyle={props.tag?.iconStyle} />
        )}
      </div>
    );
  };

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <div className="_full-width _full-height _position-relative">
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
            }}
            src={props.thumbSrc}
            className="radius-12 _full-width _full-height"
            alt={window.i18next.t('pmwjs_image')}
            draggable="false"
            loading="lazy"
          />
          {props.tag ? getTag() : null}
        </div>
      }
    />
  );
}
